const isPlainObject = (value) =>
  value !== null && typeof value === 'object' && !Array.isArray(value);

export const deepMerge = (target, patch) => {
  if (!isPlainObject(patch)) return target;
  const result = { ...target };
  Object.keys(patch).forEach((key) => {
    const patchValue = patch[key];
    if (patchValue === undefined) return;
    if (isPlainObject(patchValue) && isPlainObject(target[key])) {
      result[key] = deepMerge(target[key], patchValue);
    } else {
      result[key] = patchValue;
    }
  });
  return result;
};

export const applyElementPatch = (element, patch) =>
  deepMerge(element, patch);

export const createElementId = () =>
  `el-${Date.now()}-${Math.floor(Math.random() * 100000)}`;

export const duplicateSelectedElements = (elements, selectedIds, offset = 10) => {
  const selected = elements.filter((el) => selectedIds.includes(el.id));
  if (!selected.length) return { elements, newIds: [] };
  const maxZ = Math.max(...elements.map((el) => el.zIndex || 0), 0);
  const newElements = selected.map((el, index) => ({
    ...el,
    id: createElementId(),
    x: el.x + offset,
    y: el.y + offset,
    zIndex: maxZ + index + 1,
    locked: false,
  }));
  return {
    elements: [...elements, ...newElements],
    newIds: newElements.map((el) => el.id),
  };
};
